import React, { useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Grid, Typography, Card, CardContent, Avatar } from "@mui/material";
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles

const WhatWeDo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with options
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#F5F5F5",
        paddingBottom: { xs: "2rem", md: "4rem" },
      }}
    >
      {/* Heading */}
      <Typography
        variant="h4"
        align="center"
        sx={{
          color: "#6A983C",
          marginBottom: { xs: "1.5rem", md: "2rem" },
          fontWeight: "bold",
          fontFamily: '"Montserrat", sans-serif',
        }}
        data-aos="fade-up"
      >
        What We Do
      </Typography>

      {/* Blurred Background Image */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "200px", md: "300px" },
          backgroundImage: "url(https://i.postimg.cc/L5sQM2yD/Group-166.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "8px",
        }}
        data-aos="fade-up"
      >
        {/* Overlay Cards */}
        <Grid
          container
          spacing={1}
          sx={{
            position: "absolute",
            bottom: { xs: "-40px", md: "-60px" },
            left: "50%",
            transform: "translateX(-50%)",
            width: { xs: "95%", md: "85%" },
            justifyContent: "center",
          }}
        >
          {[
            {
              title: "Packaging",
              description:
                "Packaging is the key in increasing supply chain efficiency and export quality. C.G.L worked in packaging operations for years, accumulating dependable skills and a wealth of expertise.",
              bgImage: "https://i.postimg.cc/tJjFzFRD/Group-170.png",
            },
            {
              title: "Cutting cost",
              description:
                "Cutting costs in a CGL trading company focuses on reducing expenses, optimizing supply chains, and lowering overhead to ensure efficiency and sustainable growth.",
              bgImage: "https://i.postimg.cc/QxbxC12s/Group-169.png",
            },
            {
              title: "Reduce working time",
              description:
                "Reducing environmental impact in a CGL trading company involves optimizing supply chains, minimizing waste, and reducing working hours to save energy.",
              bgImage: "https://i.postimg.cc/MKdqqxBp/Group-171.png",
            },
          ].map((item, index) => (
            <Grid item xs={4} key={index}>
              <Card
                sx={{
                  backgroundImage: `url(${item.bgImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#fff",
                  height: { xs: "120px", md: "180px" },
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius:"20px"
                }}
                data-aos="zoom-in"
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: { xs: "8px", md: "1.25rem" },fontFamily: '"Montserrat", sans-serif', }}
                    gutterBottom
                  >
                    <b>{item.title}</b>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: "6px", md: "1rem" },
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                    }}
                  >
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        
      </Box>
      <Grid
        container
        spacing={4}
        sx={{
          marginTop: { xs: '7rem', md: '10rem' },
          padding: { xs: '1rem', md: '0 2rem' },
        }}
      >
        <Grid item xs={12} md={6}>
          <Box sx={{ position: 'relative', width: { xs: '80%', md: '70%' }, margin: '0 auto' }}>
            {/* Avatar */}
            <Avatar
              src="https://i.postimg.cc/65Z6cDsZ/2ffbe5f7545947a79cfc489cd45e8c3d-1.png"
              alt="Person Image"
              sx={{
                width: '100%', // Match the width of the parent Box
                height: 'auto',
                borderRadius: '102px 0 0 0', // Top-left corner only
                boxShadow: 3,
              }}
               data-aos="fade-right"
            />

            {/* Tab with "100% Trusted" */}
            <Box
              sx={{
                position: 'absolute',
                top: '40px', // Shift slightly upward
                right: '-40px', // Shift slightly outward
                transform: 'translate(50%, -50%)', // 50% inside and 50% outside
                backgroundColor: '#E3EBD4', // Golden tan color
                color: 'black', // White text
                borderRadius: '8px', // Fully rounded corners
                padding: '6px 12px', // Padding inside the tab
                display: 'flex',
                alignItems: 'center',
                gap: '6px', // Space between text and icon
                fontSize: { xs: '10px', md: '12px' }, // Responsive font size
                fontWeight: 'bold',
                zIndex: 2, // Ensure it stays on top of the image
                boxShadow: 2, // Add a shadow to make it stand out
              }}
              data-aos="fade-right"
            >
              <CheckCircleIcon sx={{ fontSize: { xs: '14px', md: '16px' } }} /> {/* Tick Icon */}
              100% Trusted
            </Box>
          </Box>
        </Grid>


        {/* Right Side - Text */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              color: '#6A983C',
              marginBottom: '1rem',
              fontWeight: 'bold',
              fontSize: { xs: '1.25rem', md: '1.5rem' }, // Adjusted for mobile
              textAlign: "center",
              fontFamily: '"Montserrat", sans-serif',
            }}
            data-aos="fade-left"
          >
            Purchasing Service to <br />Accelerate Global <br /> Procurement
          </Typography>
          <Typography variant="body1" data-aos="fade-left" sx={{ marginBottom: '1.5rem', color: "#98AF41", fontSize: { xs: '0.875rem', md: '1rem' } }}>
            Sourcing foodstuffs internationally is an unavoidable reality for traders, but it comes with challenges such
            as troublesome customs clearance, high demand for authorized food goods, and issues with product stock and
            cash flow. These problems can create conflicts between producers and suppliers, hampering procurement.
          </Typography>
          <Typography  data-aos="fade-left"  variant="body2" sx={{ color: "#98AF41", fontSize: { xs: '0.75rem', md: '0.875rem' } }}>
            C.G.L General Trading provides a purchasing service to resolve these issues by temporarily holding
            procurement goods as C.G.L assets, helping with off-balance sheet and cash flow management, and delivering
            major benefits to both producers and suppliers.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WhatWeDo;
